import type { ReactNode } from 'react';
import * as RadixTooltip from '@radix-ui/react-tooltip';

/** Shares hover delays between tooltips. Mounted once in UiProvider. */
export const TooltipProvider = RadixTooltip.Provider;

export interface TooltipProps {
  /** The tooltip text. Supplementary only: never the sole name of a control (use aria-label). */
  content: ReactNode;
  /** One focusable or hoverable element (rendered as the trigger via asChild). */
  children: ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
  /** When true, renders the child alone (e.g. tooltips only for a collapsed sidebar). */
  disabled?: boolean;
}

/** Small dark label on hover or keyboard focus. */
export function Tooltip({ content, children, side = 'top', disabled }: TooltipProps) {
  if (disabled) return <>{children}</>;
  return (
    <RadixTooltip.Root>
      <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
      <RadixTooltip.Portal>
        <RadixTooltip.Content
          side={side}
          sideOffset={6}
          className="z-50 max-w-xs rounded-md bg-navy-ink px-2 py-1 font-sans text-xs text-white shadow-pop"
        >
          {content}
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  );
}
